export const LARGE_SCREEN_SIZE = 992
export const AXIOS_TIMEOUT = 30000;

export const LOCAL_STORAGE_KEY = "local";
export const SERVER_ERR_MSG = "Server Error!";

export const DEFAULT_ERROR_MSG = "Error! Something went wrong.";
export const TOAST_GLOBAL_CONFIG = { position: "top-right", dismissible: true };

export const DATE_OPTIONS : Intl.DateTimeFormatOptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
export const DATETIME_OPTIONS : Intl.DateTimeFormatOptions = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };

// Object storage — receipt images are stored under VERIFICATION_IMAGE_DIR and
// the public URL is `${STORAGE_URL}/${VERIFICATION_IMAGE_DIR}/<filename>`.
export const STORAGE_URL = 'https://abol-verify-storage.fra1.digitaloceanspaces.com';
export const VERIFICATION_IMAGE_DIR = 'documents/verification_images';
export const DEFAULT_CURRENCY = 'ETB';

// Where desktop users are sent to get the mobile app for receipt scanning.
// TODO: update to the real listing once the app is published (the Flutter app's
// applicationId is still the placeholder com.example.abol_verify_app).
export const PLAY_STORE_URL =
    'https://play.google.com/store/apps/details?id=com.example.abol_verify_app';
